import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PrivacyNoticeComponent } from '@components/footer/privacy-notice/privacy-notice.component';
import { UserService } from '@services/user/user.service';
import { User } from '@app/shared/models/user.interface';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  imports: [RouterLink],
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
  currentYear = new Date().getFullYear();
  dialogRef: MatDialogRef<PrivacyNoticeComponent, any>;

  constructor(private readonly userService: UserService, private readonly dialog: MatDialog) {}

  ngOnDestroy(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  ngOnInit(): void {
    this.userService.getCurrentUser().subscribe((user: User) => {
      if (user.joinedAt == null) {
        this.dialogRef = this.showPrivacyPolicy(true);
      }
    });
  }

  showPrivacyPolicy(showActions: boolean): MatDialogRef<PrivacyNoticeComponent, any> {
    return this.dialog.open(PrivacyNoticeComponent, { data: showActions, disableClose: true });
  }
}
